import { deconstructEncryptedPayloadString } from '../../V004AlgorithmHelpers';
import { StringToAuthenticatedDataUseCase } from '../Utils/StringToAuthenticatedData';
import { CreateConsistentBase64JsonPayloadUseCase } from '../Utils/CreateConsistentBase64JsonPayload';
import { GenerateSymmetricPayloadSignatureResultUseCase } from './GenerateSymmetricPayloadSignatureResult';
import { DeriveHashingKeyUseCase } from '../Hash/DeriveHashingKey';
export class GenerateDecryptedParametersUseCase {
    constructor(crypto) {
        this.crypto = crypto;
        this.base64DataUsecase = new CreateConsistentBase64JsonPayloadUseCase(this.crypto);
        this.stringToAuthenticatedDataUseCase = new StringToAuthenticatedDataUseCase(this.crypto);
        this.signingVerificationUseCase = new GenerateSymmetricPayloadSignatureResultUseCase(this.crypto);
        this.deriveHashingKeyUseCase = new DeriveHashingKeyUseCase(this.crypto);
    }
    execute(encrypted, key) {
        const contentKeyResult = this.decryptContentKey(encrypted, key);
        if (!contentKeyResult) {
            console.error('Error decrypting contentKey from parameters', encrypted);
            return {
                uuid: encrypted.uuid,
                errorDecrypting: true,
            };
        }
        const contentResult = this.decryptContent(encrypted, contentKeyResult.decrypted);
        if (!contentResult) {
            return {
                uuid: encrypted.uuid,
                errorDecrypting: true,
            };
        }
        const hashingKey = this.deriveHashingKeyUseCase.execute(key);
        const signatureVerificationResult = this.signingVerificationUseCase.execute(encrypted, hashingKey, {
            additionalData: contentKeyResult.components.additionalData,
            plaintext: contentKeyResult.decrypted,
        }, {
            additionalData: contentResult.components.additionalData,
            plaintext: contentResult.decrypted,
        });
        return {
            uuid: encrypted.uuid,
            content: JSON.parse(contentResult.decrypted),
            signatureData: signatureVerificationResult,
        };
    }
    decryptContent(encrypted, contentKey) {
        const contentComponents = deconstructEncryptedPayloadString(encrypted.content);
        return this.decrypt(encrypted, contentComponents, contentKey);
    }
    decryptContentKey(encrypted, key) {
        const contentKeyComponents = deconstructEncryptedPayloadString(encrypted.enc_item_key);
        return this.decrypt(encrypted, contentKeyComponents, key.itemsKey);
    }
    decrypt(encrypted, components, key) {
        const rawAuthenticatedData = this.stringToAuthenticatedDataUseCase.executeRaw(components.authenticatedData);
        const doesRawContainLegacyUppercaseUuid = /[A-Z]/.test(rawAuthenticatedData.u);
        const authenticatedData = this.stringToAuthenticatedDataUseCase.execute(components.authenticatedData, {
            u: doesRawContainLegacyUppercaseUuid ? encrypted.uuid.toUpperCase() : encrypted.uuid,
            v: encrypted.version,
            ksi: encrypted.key_system_identifier,
            svu: encrypted.shared_vault_uuid,
        });
        const authenticatedDataString = this.base64DataUsecase.execute(authenticatedData);
        const decrypted = this.crypto.xchacha20Decrypt(components.ciphertext, components.nonce, key, authenticatedDataString);
        if (!decrypted) {
            return null;
        }
        return {
            decrypted,
            components: components,
            authenticatedDataString,
        };
    }
}
